import video from "./../pics/video_d.mp4";
import video_m from "./../pics/video_m.mp4";
import "./../Style.css";
import { isMobile } from "react-device-detect";
import { useEffect, useState } from "react";
import {
  HomeAbout,
  HomeMenu,
  HomeReservation,
  HomeSustainable,
} from "./ContactDesktop";
import { Photos, PhotosMobile } from "./PicGallery";
import { HomeAboutMobile, HomeSustainableMobile } from "./ContactMobile";
import { PlacePhotos, PlacePhotosMobile } from "./PicGallery2";

export const Home = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const MobileView = () => {
    return (
      <>
        <div className="homepage">
          {/* <AsyncImage
          style={styledd}
          src={start}
          Transition={Fade}
          error={
            <div style={{ background: "#eee", height: 500, width: 500 }} />
          }
        /> */}
          {!videoLoaded && (
            <div className="video-loader">
              <div className="spinner"></div>
            </div>
          )}
          <div className="videocontainer">
            <video
              autoPlay
              loop
              muted
              playsInline
              src={video_m}
              className="video_m"
              onLoadedData={() => setVideoLoaded(true)}
            ></video>
          </div>
          <HomeReservation />
          <PhotosMobile />
          <HomeAboutMobile />
          <PlacePhotosMobile />
          <HomeMenu />
          <HomeSustainableMobile />
        </div>
      </>
    );
  };

  const DesktopView = () => {
    return (
      <div className="homepage">
        {/* <AsyncImage
          style={styled}
          src={start}
          Transition={Fade}
          error={
            <div style={{ background: "#eee", height: 500, width: 500 }} />
          }
        /> */}
        {!videoLoaded && (
          <div className="video-loader">
            <div className="spinner"></div>
          </div>
        )}
        <div className="videocontainer">
          <video
            autoPlay
            loop
            muted
            playsInline
            src={video}
            className="video"
            onLoadedData={() => setVideoLoaded(true)} // Hides loader when video is ready
          ></video>
        </div>
        <HomeReservation />
        <Photos />
        <HomeAbout />
        <PlacePhotos />
        <HomeMenu />
        <HomeSustainable />
      </div>
    );
  };
  return <div>{isMobile ? <MobileView /> : <DesktopView />}</div>;
};
